export default __webpack_public_path__ + "static/media/gif_ei.771c0042.gif";